import React, { useCallback } from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { ClientNationalityDto } from 'api/Clients/Types/ClientDetailedDto'
import { Loading } from 'components/Loading'
import styled from 'styled-components'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { useFetchOne } from 'utils/api/useFetch'
import { formatLocalDateUTC } from 'utils/date'

import ClientDetailsNCIAdd from './ClientDetailsNCIAddForm'

const Container = styled.div`
  margin: 2.5rem;
`

interface OuterProps {
  clientsApiClient: ClientsApiClient
  clientId: string
  tickmillCompanyId: number
  showAddForm?: boolean
  countries: ClientNationalityDto[]

  closeModal(): void
}

export const ClientDetailsNCIHistory: React.FC<OuterProps> = ({
  clientsApiClient,
  clientId,
  tickmillCompanyId,
  showAddForm,
  closeModal,
  countries,
}) => {
  const historyData = useCallback(() => clientsApiClient.getClientNCIHistory(clientId), [clientId]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(historyData)

  if (showAddForm) {
    return (
      <ClientDetailsNCIAdd
        countries={countries}
        closeModal={closeModal}
        clientId={clientId}
        tickmillCompanyId={tickmillCompanyId}
      />
    )
  }
  return (
    <Container>
      <Loading isLoading={isLoading} modalView={true}>
        <Grid data={data || []} total={(data || []).length} resizable style={{ zIndex: 0 }}>
          <Column
            title='Priority'
            width={80}
            field='priority.priority'
            className='table-columns__content'
          />
          <Column
            title='NCI Rule'
            field='priority.nciRule.name'
            className='table-columns__content'
          />
          <Column title='Country' field='country.name' className='table-columns__content' />
          <Column
            title='NCI Type'
            field='priority.nciRule.nciType'
            className='table-columns__content'
          />
          <Column
            title='NCI Document Number'
            field='nciDocumentNumber'
            className='table-columns__content'
          />
          <Column
            title='Document Type'
            field='documentType.name'
            className='table-columns__content'
          />
          <Column title='Status' field='status.name' className='table-columns__content' />
          <Column title='User' field='user.name' className='table-columns__content' />
          <Column title='Client Response' field='reason' className='table-columns__content' />
          <Column
            title='Created'
            cell={(props: GridCellProps) => (
              <td className='table-columns__date'>
                {formatLocalDateUTC(props.dataItem.created, true)}
              </td>
            )}
          />
        </Grid>
      </Loading>
    </Container>
  )
}
